import { CardAction } from "@components/progress-overview/card-action-button";
import { CardActionMenu } from "@components/progress-overview/card-action-menu";
import { Stack, SxProps, Theme, Typography } from "@mui/material";
import { neutral } from "@flat-ui";
import { DEFAULT_TEXT_FONT_SIZE, withEllipsis } from "@styles/common-styles";
import { PropsWithChildren, ReactNode } from "react";

export interface CardLayoutProps {
  /** Name of the uploaded file */
  name: string;

  /** Name of the target project for this upload */
  projectName?: string;

  /** A menu with multiple actions */
  menu?: CardAction[];

  /** An icon to show before the name if available */
  icon?: ReactNode;

  /** Optional style to apply the the wrapper of the title */
  titleWrapperSx?: SxProps<Theme>;
}

/** Renders the main layout of a menu card */
export function CardLayout({
  name,
  projectName,
  menu,
  icon,
  titleWrapperSx,
  children,
}: PropsWithChildren<CardLayoutProps>): JSX.Element {
  return (
    <Stack sx={{ p: 0.5, mx: 4 }}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        gap={0.375}
        sx={titleWrapperSx}
      >
        {icon}
        <Typography
          fontSize="14px"
          flex="1"
          sx={{ ...withEllipsis, color: neutral[800] }}
        >
          <var>{name}</var>
        </Typography>

        {menu && <CardActionMenu menu={menu} />}
      </Stack>

      {projectName && (
        <Typography
          fontSize={DEFAULT_TEXT_FONT_SIZE}
          sx={{
            pb: 1.25,
            ...withEllipsis,
            color: neutral[600],
          }}
        >
          <var>{projectName}</var>
        </Typography>
      )}
      <Stack component="div" sx={{ pb: 1.5 }} gap={1}>
        {children}
      </Stack>
    </Stack>
  );
}
